module.exports = __webpack_public_path__ + "img/welion.d30a032e.png";